export default "__VITE_ASSET__73e3e3db__"